const EXTENSION_LOGIN_KEY = 'di_extension_login'
const EXTENSION_REDIRECT_KEY = 'di_extension_redirect'
const EXTENSION_TS_KEY = 'di_extension_login_ts'
export const EXTENSION_LOGIN_TTL_MS = 5 * 60 * 1000

export type ExtensionAuthPayload = {
  idToken: string
  refreshToken: string
  tokenExpiry: string | number
}

export type ExtensionLoginIntent = {
  isExtension: boolean
  redirectUri: string | null
}

export function readExtensionIntentFromQuery(search = ''): ExtensionLoginIntent {
  if (typeof window === 'undefined') {
    return {
      isExtension: false,
      redirectUri: null,
    }
  }

  const query = search || window.location.search
  const params = new URLSearchParams(query)
  const source = params.get('source')
  const redirectUri = params.get('redirectUri')

  let decodedRedirectUri: string | null = null
  if (redirectUri) {
    try {
      decodedRedirectUri = decodeURIComponent(redirectUri)
    } catch {
      decodedRedirectUri = redirectUri
    }
  }

  return {
    isExtension: source === 'chrome-extension',
    redirectUri: decodedRedirectUri,
  }
}

export function saveExtensionIntent(intent: ExtensionLoginIntent): void {
  if (!intent.isExtension) return
  sessionStorage.setItem(EXTENSION_LOGIN_KEY, '1')
  sessionStorage.setItem(EXTENSION_TS_KEY, String(Date.now()))
  if (intent.redirectUri) sessionStorage.setItem(EXTENSION_REDIRECT_KEY, intent.redirectUri)
  else sessionStorage.removeItem(EXTENSION_REDIRECT_KEY)
}

export function restoreExtensionIntent(): ExtensionLoginIntent {
  const isExtension = sessionStorage.getItem(EXTENSION_LOGIN_KEY) === '1'
  const createdAt = Number(sessionStorage.getItem(EXTENSION_TS_KEY) || 0)

  if (!isExtension || !createdAt || Date.now() - createdAt > EXTENSION_LOGIN_TTL_MS) {
    clearExtensionIntent()
    return {
      isExtension: false,
      redirectUri: null,
    }
  }

  return {
    isExtension: true,
    redirectUri: sessionStorage.getItem(EXTENSION_REDIRECT_KEY),
  }
}

export function clearExtensionIntent(): void {
  sessionStorage.removeItem(EXTENSION_LOGIN_KEY)
  sessionStorage.removeItem(EXTENSION_TS_KEY)
  sessionStorage.removeItem(EXTENSION_REDIRECT_KEY)
}

function isValidPayload(payload: ExtensionAuthPayload): payload is ExtensionAuthPayload {
  return (
    typeof payload.idToken === 'string' &&
    payload.idToken.length > 0 &&
    typeof payload.refreshToken === 'string' &&
    payload.refreshToken.length > 0 &&
    (typeof payload.tokenExpiry === 'string' || typeof payload.tokenExpiry === 'number')
  )
}

export function postAuthSuccessToExtension(payload: ExtensionAuthPayload): void {
  if (!isValidPayload(payload)) return
  window.postMessage(
    {
      type: 'AUTH_SUCCESS',
      source: 'dashboard-insights-app',
      payload,
    },
    window.location.origin
  )
}

export function handleExtensionCheckMessage(event: MessageEvent): void {
  const data = event.data as { type?: string; source?: string } | null
  if (event.origin !== window.location.origin) return
  if (data?.type !== 'EXTENSION_CHECK' || data?.source !== 'dashboard-insights-app') return

  window.postMessage(
    {
      type: 'EXTENSION_RESPONSE',
      source: 'dashboard-insights-extension',
      available: true,
    },
    window.location.origin
  )
}
